import React from 'react';
import Icon from '../atoms/Icon';

function FlagIcon (props:any, ref:React.Ref<any>) {
  return (
    <Icon {...props} ref={ref} viewBox='0 0 29 32'>
      <g
        fill='currentColor'
        fillRule='nonzero'
      >
        <path d='M7.99998 4.79999C10.0444 4.79999 11.2844 5.43124 12.8844 6.23124C14.4844 7.03124 16.4444 7.99999 19.2 7.99999C21.5551 7.99999 23.8767 7.43485 25.6 6.94061V19.5031C24.5236 19.8263 21.4774 20.8 19.2 20.8C17.1555 20.8 15.9156 20.1687 14.3156 19.3687C12.7156 18.5687 10.7555 17.6 7.99998 17.6C6.19218 17.6 4.49896 18.0284 3.19998 18.4562V5.88749C4.15388 5.49058 5.97393 4.79999 7.99998 4.79999Z' />
      </g>

      <g
        fill='black'
        fillRule='nonzero'
      >
        <path d='M0 0V1.6V3.8125V23.3875V30.4V32H3.2V30.4V21.8875C4.15389 21.4906 5.97394 20.8 8 20.8C10.0444 20.8 11.2844 21.4313 12.8844 22.2313C14.4844 23.0313 16.4444 24 19.2 24C22.9333 24 27.7062 22.3188 27.7062 22.3188L28.8 21.9531V2.58125L26.6937 3.28125C26.6937 3.28125 21.8667 4.8 19.2 4.8C17.1556 4.8 15.9156 4.16875 14.3156 3.36875C12.7156 2.56875 10.7556 1.6 8 1.6C6.1922 1.6 4.49898 2.02839 3.2 2.45625V1.6V0H0ZM8 4.8C10.0444 4.8 11.2844 5.43125 12.8844 6.23125C14.4844 7.03125 16.4444 8 19.2 8C21.5551 8 23.8767 7.43486 25.6 6.94063V19.5031C24.5236 19.8263 21.4774 20.8 19.2 20.8C17.1556 20.8 15.9156 20.1687 14.3156 19.3687C12.7156 18.5687 10.7556 17.6 8 17.6C6.1922 17.6 4.49898 18.0284 3.2 18.4563V5.8875C4.15389 5.4906 5.97394 4.8 8 4.8Z' />
      </g>
    </Icon>
  );
}

export default React.forwardRef(FlagIcon);
